import { FlexBox, Spinner } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';
import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { DeepWritable } from 'ts-essentials';

import { useUpload } from 'apis/uploads';
// eslint-disable-next-line no-restricted-imports
import AvatarControl from 'components/shared/avatarControl/components/AvatarControl';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { dataUriToFile } from 'utils/file/dataUriToFile';

import styles from './mimUserAvatartControl.module.scss';

export const MimUserAvatarControl = (): JSX.Element => {
  const notify = useNotifications();

  const { setValue, getValues } = useFormContext();

  const [upload, { asyncStatus: uploadAsyncStatus }] = useUpload();

  const avatarUrl = getValues('userAvatarUrl');
  const [user, setUser] = useState({
    id: '',
    avatar_url: avatarUrl,
  } as User);
  useEffect(() => {
    setUser((prevUser) => ({ ...prevUser, avatar_url: avatarUrl }));
  }, [avatarUrl]);

  const handleSelectAvatar = useCallback(
    async (dataURI: string) => {
      const file = await dataUriToFile(dataURI, 'user');

      try {
        const { url } = await upload({
          file,
          type: 'user_avatar',
        });

        if (url) {
          setValue('userAvatarUrl', url, { shouldDirty: true });
          setUser((prevUser) => ({ ...prevUser, avatar_url: url }));
        }
      } catch (error) {
        notify(
          {
            title: 'Error while updating the user.',
          },
          NotificationType.Error,
        );
      }
    },
    [notify, setValue, upload],
  );

  const handleDeleteAvatar = useCallback(() => {
    setValue('userAvatarUrl', '', { shouldDirty: true });
    setUser((prevUser) => ({ ...prevUser, avatar_url: '' }));
  }, [setValue]);

  return (
    <FlexBox margin="0 0 400 0" alignItems="center" gap="200">
      <AvatarControl
        className={styles.avatarControl}
        type="user"
        user={user as DeepWritable<User>}
        onSelectAvatar={handleSelectAvatar}
        onDeleteAvatar={handleDeleteAvatar}
      />

      {uploadAsyncStatus === 'pending' && <Spinner size={20} />}
    </FlexBox>
  );
};
